<template>
  <div class="menu">
    <div class="menu-cover"></div>
      <div class="full-screen">
        <div class="screen-left"></div>
        <div class="menu-locker-box">
            <!-- 登录未登录和各种头像来回切换 -->
            <div class="change-status">
                <!-- 头像和提示 -->
                <div class="imgs-title">
                    <img src="/static/img/yonghu-2.png" alt="" class="default-img portrait-img">
                    <!-- 未登录的tag p -->
                    <p class="no-login-toggle">
                        <a href="http://m.member.breadoffer.com/login.html">立即登录</a>
                    </p>
                    <!-- 已登录的tag p -->
                    <p class="has-login-toggle has-logined">
                        <a href="http://m.member.breadoffer.com">进入会员中心</a>
                    </p>
                    <!-- 搜索的容器定位 -->
                    <a class="search-btn" href="http://m.breadoffer.com/search.html?back=college&path=index"><i class="iconfont icon-sousuo"></i></a>
                </div>
            </div>
            <!-- 下方导航列表 -->
            <div class="menu-nav">
              <ul class="nav-list">
                <li v-for="item in navArr" class="lock-nav-item active-nav-item">
                  <a :href="item.url" class="locker-nav-a">
                    <!-- 左侧导航条 -->
                    <i class="active-left-border" v-show="path == item.path"></i>
                    <div class="locker-nav-cont border-after">
                      <!-- svg图标 -->
                      <span class="nav-icon">
                          <svg class="icon" aria-hidden="true">
                            <use :xlink:href="item.icon"></use>
                          </svg>
                      </span>
                      <!-- 导航name -->
                      <span class="locker-nav-option" :class="{'active':path == item.path}">{{item.name}}</span>
                    </div>
                  </a>
                </li>
                <li class="lock-nav-item active-nav-item has-login-toggle has-logined">
                  <a :href="logoutItem.url" class="locker-nav-a">
                    <!-- 左侧导航条 -->
                    <i class="active-left-border" v-show="path == logoutItem.path"></i>
                    <div class="locker-nav-cont border-after">
                      <!-- svg图标 -->
                      <span class="nav-icon">
                          <svg class="icon" aria-hidden="true">
                            <use :xlink:href="logoutItem.icon"></use>
                          </svg>
                      </span>
                      <!-- 导航name -->
                      <span class="locker-nav-option" :class="{'active':path == logoutItem.path}">{{logoutItem.name}}</span>
                    </div>
                  </a>
                </li>
<!--                <li v-for="item in navArr" class="lock-nav-item active-nav-item">-->
<!--                  <a :href="item.url" class="locker-nav-a">-->
<!--                    <span class="nav-icon">-->
<!--                      <i :class="item.iconClass">{{item.aliIcon}}</i>-->
<!--                    </span>-->
<!--                    <span class="locker-nav-option">{{item.name}}</span>-->
<!--                  </a>-->
<!--                </li>-->
              </ul>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import $ from 'jquery';
  export default {
    data(){
      return{
        path:'',
        baseUrl:'http://m.college.breadoffer.com',
        navArr:[
          // {url:'/',name:'面包学院首页',icon:'#icon-xueyuanshouye',path:null},
          {url:'http://m.breadoffer.com',name:'首页',icon:'#icon-xueyuanshouye',path:'activity'},
          {url:'/module/list.html?source=recruitinner',name:'内推',icon:'#icon-xueyuan-neitui',path:'recruitinner'},
          {url:'http://m.breadoffer.com/course/list.html',name:'课程',icon:'#icon-xueyuan-ganhuo',path:'knowledge'},
          {url:'http://m.breadoffer.com/teacher/list.html',name:'导师',icon:'#icon-zhiwei',path:'knowledge'},
          {url:'http://m.breadoffer.com/gain.html',name:'成果',icon:'#icon-xueyuan-huodong',path:'knowledge'},
          {url:'http://m.breadoffer.com/aboutus/about.html',name:'关于',icon:'#icon-xueyuan-xinwen',path:'industry'},
          {url:'http://m.breadoffer.com/job/recruit.html',name:'导师招募',icon:'#icon-xueyuan-zhaopin',path:'recruitouter'}
          // {url:'http://m.breadoffer.com',name:'返回面包主站',icon:'#icon-xueyuanfanhui',path:''},
        ],
        logoutItem: {url:'http://m.member.breadoffer.com/logout?forward=http://m.member.breadoffer.com/login.html',name:'退出登录',icon:'#icon-xueyuandengchu',path:''},
        // navArr:[
        //   {url:'http://m.breadoffer.com',name:'首页',iconClass:"iconfont round locker-icon-1",aliIcon:'&#xe60a;',path:null},
        //   {url:'http://m.college.breadoffer.com/module/list.html?source=recruitinner',name:'内推',iconClass:"iconfont caifuxueyuan locker-icon-4",aliIcon:'&#xe64c;',path:null},
        //   {url:'http://m.breadoffer.com/course/list.html',name:'课程',iconClass:"kechengline locker-icon-2",aliIcon:'&#xe603;',path:null},
        //   {url:'http://m.breadoffer.com/teacher/list.html',name:'导师',iconClass:"iconfont tuandui1 locker-icon-3",aliIcon:'&#xe606;',path:null},
        //   {url:'http://m.breadoffer.com/gain.html',name:'成果',iconClass:"xinfuben locker-icon-5",aliIcon:'&#xe607;',path:null},
        //   {url:'http://m.breadoffer.com/aboutus/about.html',name:'关于',iconClass:"wodedingdan37 locker-icon-6",aliIcon:'&#xe628;',path:null},
        //   {url:'http://m.breadoffer.com/job/recruit.html',name:'导师招募',iconClass:"iconfont job locker-icon-4",aliIcon:'&#xe61a;',path:null},
        //   {url:'http://m.member.breadoffer.com/logout?forward=http://m.member.breadoffer.com/login.html',name:'首页',iconClass:"iconfont locker-icon-4",aliIcon:'&#xe656;',path:null}
        //   // {url:'/module/list.html?source=knowledge',name:'干货',icon:'#icon-xueyuan-ganhuo',path:'knowledge'},
        //   // {url:'/module/list.html?source=activity',name:'活动',icon:'#icon-xueyuan-huodong',path:'activity'},
        //   // {url:'/module/list.html?source=recruitinner',name:'内推',icon:'#icon-xueyuan-neitui',path:'recruitinner'},
        //   // {url:'/module/list.html?source=recruitouter',name:'招聘',icon:'#icon-xueyuan-zhaopin',path:'recruitouter'},
        //   // {url:'/module/list.html?source=industry',name:'新闻',icon:'#icon-xueyuan-xinwen',path:'industry'},
        //   // {url:'http://m.breadoffer.com',name:'返回面包主站',icon:'#icon-xueyuanfanhui',path:''},
        //   // {url:'http://m.member.breadoffer.com/logout?forward=http://m.member.breadoffer.com/login.html',name:'退出登录',icon:'#icon-xueyuandengchu',path:''},
        // ]
      }
    },
    methods:{
      GetQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
      }
    },
    mounted(){
      this.path = this.GetQueryString("source");
    }
  }
</script>

<style scoped lang="scss">
@import  "../../sass/mixin";

.menu{
  height:100%;
}
.active{
  color:#f5c500 !important;
}
/*30%透明度的黑色遮罩*/
.menu-cover {
	display: none;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 1200;
	width: 100%;
	height: 100%;
	background: #333;
	opacity: .3;
}
.full-screen {
	position: fixed;
	width:100%;
	height:100%;
	left:100%;
	bottom:0;
	right:0;
	z-index: 9999;
	transition: all 0.3s ease;

  .screen-left {
  	position: absolute;
  	top:0;
  	left:0;
  	width:17%;
  	height:100%;
  }
}
  .blur-active {
  	filter: blur(5px);
  	-webkit-filter:blur(5px);
  	opacity: 0.9;
  	-webkit-backface-visibility:hidden;
  }

  .menu-locker-box {
  	  position: absolute;
  	  right:0;
      top: 0.04rem;
      width: 83%;
      height:100%;
      z-index: 60;
      transition: all 0.3s ease;
      background-color: #fff;
      overflow-y:auto;

    /*状态切换的容器*/
    .change-status {
    	position: relative;
    	width:100%;
    	height: 1.25rem;
    	background: url(/static/img/locker-bg.png);
    	background-size: 100% 100%;

      .imgs-title{
      	text-align: center;
      	font-size: 0.12rem;
      	padding-top: 0.22rem;

        p {
          line-height: 0.2rem !important;
          a{
            color: #546dbe;
            font-size: .12rem;
          }
        }

        .has-logined {
        	color: #555555;
        }
        /*--- 搜索btn begin ---*/
        .search-btn {
        	display: block;
        	position: absolute;
        	top: 0.35rem;
        	right: 0.4rem;
        	width: 0.40rem;
        	height: 0.40rem;
        	border: 0.03rem solid rgba(84, 109, 190, 0.15);
        	border-radius: 50%;
        	background: rgba(255,255,255,0.5);
        	text-align: center;

          i {
          	display: block;
          	height: 100%;
          	margin-left: .01rem;
          	color: #7a819c;
          	font-size: .16rem;
          	/*line-height: 0.4rem;*/
          	line-height: 0.355555rem;
          }
        }
      }
      .default-img {
      	display: block;
      	width: 0.65rem;
      	height: 0.65rem;
      	margin: 0 auto;
      	margin-bottom: 0.10rem;
      	border-radius: 50%;
      	border: .03rem solid rgba(84,109,190,.15);
      }
    }
}
//
// .all-containers {
// 	margin-top:0.04rem;
// }

/*--- 链接列表样式 begin ---*/
.menu-nav{
  width:100%;
  .nav-list{
    .lock-nav-item {
    	height: 0.49rem;
      text-align: left;

      &:nth-of-type(4){
        padding-left: .04rem;
        .nav-icon{
          margin:0 .21rem 0 -0.21rem !important;
        }
        .icon {
          font-size: .2rem;
          width:.65rem !important;
          height:.18rem !important;
        }
      }

      .locker-nav-a {
      	display: block;
      	position: relative;
      	overflow: hidden;
      	width: 100%;
      	height: 100%;
      	color: #999;
      }

      .active-left-border {
      	position: absolute;
      	top: .12rem;
      	left: 0;
      	width: .03rem;
      	height: .25rem;
      	background: #f8d85f;
      }

      .locker-nav-cont {
      	position: relative;
      	height: 100%;
      	padding: .12rem 0;
        margin-left: 0.25rem;
      	line-height: .26rem;
        border-bottom: 1px solid #eee;

        .nav-icon {
        	display: inline-block;
        	width: 0.35rem;
        	color: #f2d672;
        	vertical-align: -0.04rem;
          margin:0 .25rem 0 -0.21rem;

          .icon {
          	font-size: .2rem;
            width:.7rem;
            height:.2rem;
          }
        }

        .locker-nav-option {
        	color: #777777;
        	font-size: .12rem;
          vertical-align:.01rem;
        }
      }
      .border-after {
      	// left: .2rem;
      }
    }
  }
}
.active-nav-item .locker-nav-option, .active-nav-item .nav-icon {
  color: #546dbe;
}
/*--- 链接列表样式 end ---*/
</style>



// WEBPACK FOOTER //
// menu.vue?10bf29ed